var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-pinterest",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_white",
    "data-name": "Ellipse white",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_grey",
    "data-name": "Ellipse grey",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(5 5)",
    fill: "#e3e3e3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm1.151,13.322a2.457,2.457,0,0,1-2.093-1.068s-.5,1.973-.6,2.354a9.126,9.126,0,0,1-1.547,2.8.114.114,0,0,1-.2-.049,9.613,9.613,0,0,1,.026-3.255c.164-.7,1.1-4.668,1.1-4.668A3.3,3.3,0,0,1,7.56,8.084c0-1.27.736-2.217,1.652-2.217a1.147,1.147,0,0,1,1.155,1.286,18.4,18.4,0,0,1-.756,3.04,1.325,1.325,0,0,0,1.351,1.65c1.623,0,2.715-2.085,2.715-4.555C13.678,5.41,12.414,4,10.114,4A4.057,4.057,0,0,0,5.9,8.107a2.47,2.47,0,0,0,.566,1.68.415.415,0,0,1,.123.477c-.042.158-.135.537-.175.687a.3.3,0,0,1-.429.215A3.3,3.3,0,0,1,4.227,7.894c0-2.433,2.052-5.351,6.122-5.351A5.12,5.12,0,0,1,15.772,7.45C15.773,10.811,13.9,13.322,11.151,13.322Z",
    transform: "translate(5 5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.1aa7c43f9dd40e7ed4e2cbafc574931b.svg";
export { ForwardRef as ReactComponent };